<ng-container
  *ngIf="
    promotionLocation === 'PDP' ||
      promotionLocation === 'PLP' ||
      promotionLocation === 'SAVEDCARTDETAILS' ||
      isTruncated ||
      !checkTooltip;
    else noTooltip
  "
>
  <span
    #spanElement
    [popoverTriggerFor]="tooltip"
    [trigger]="isMobile || isTablet ? 'click' : 'hover'"
    noArrow="false"
    [placement]="placement"
    popoverClass="tooltip-text"
    shadow="true"
    maxWidth="250px"
    closeOnScroll="true"
    [innerHTML]="content | cxTruncate : [charactersLimit]"
    [closeOnRotate]="closeOnRotate"
  ></span>
</ng-container>
<ng-template #noTooltip>
  <span #spanElement noArrow="false" shadow="true" maxWidth="250px" closeOnScroll="true" [innerHTML]="content"></span>
</ng-template>
<popover #tooltip [innerHtml]="tooltipContent | cxTruncate : [700, '']"></popover>
